import React from "react";

import { ParentStateDatasource, DataSourceStateIdle } from "@schneiderpp/utils-endpoint";
import { Endpoint } from "@schneiderpp/admin-endpoint";
import { BaseComponent } from "../../../utils/BaseComponent";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { OverlayProps, Overlay } from "@schneiderpp/utils-components";
import { ds } from "../../../DataSource";
import { ROUTER_HOME } from "../../home/Router";
import { FormatFloat } from "@schneiderpp/utils-generic";

interface SupplyListState {
    providedSalesmanId: number | undefined;
    datasource: {
        SupplyList: ParentStateDatasource<typeof Endpoint.Salesman.GetSalesmanSupplies>;
    };
}

interface SupplyListProps {
    salesmanId: number;
}

class SupplyList extends BaseComponent<RouteComponentProps & SupplyListProps, SupplyListState> {
    state: SupplyListState = {
        providedSalesmanId: undefined,
        datasource: {
            SupplyList: DataSourceStateIdle
        }
    };

    private dsSupplyList = ds(Endpoint.Salesman.GetSalesmanSupplies, this, "SupplyList", () => this.context);

    componentDidMount() {
        this.getSupplyList();
    }

    render() {
        return (
            <div className="page-tab-content">
                <div className="page-table">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="w-4 t-left">Klient</th>
                                <th className="w-4 t-center">Wartość</th>
                                <th className="w-4">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.supplyList.map((supply) => (
                                <tr
                                    className="clickable"
                                    key={supply.SupplyId}
                                    onClick={() =>
                                        this.props.history.push({
                                            pathname: ROUTER_HOME.Supplies.List,
                                            search: `SupplyId=${supply.SupplyId}`
                                        })
                                    }
                                >
                                    <td className="t-left">{supply.Client.Name}</td>
                                    <td className="t-center">{FormatFloat(supply.Value)}</td>
                                    <td className="t-center">{supply.Status.Name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Overlay {...this.overlayProps} />
            </div>
        );
    }

    get supplyList() {
        const dsSupplyListData = this.dsSupplyList.dataSourceStorage;
        if (dsSupplyListData.state === "completed") {
            return dsSupplyListData.response.Supplies;
        }
        return [];
    }

    get overlayProps(): OverlayProps {
        if (this.dsSupplyList.state === "pending" || this.dsSupplyList.state === "idle") {
            return {
                show: true,
                title: "Ładowanie..."
            };
        }
        if (this.dsSupplyList.state === "error") {
            return {
                show: true,
                title: "Coś poszło nie tak",
                description: typeof this.dsSupplyList.error === "string" ? this.dsSupplyList.error : "",
                children: (
                    <div className="overlay__children">
                        <button className="button light" onClick={() => this.getSupplyList()}>
                            Spróbuj ponownie
                        </button>
                    </div>
                )
            };
        }
        return {
            show: false
        };
    }

    private async getSupplyList() {
        await this.dsSupplyList.request({
            params: {
                SalesmanId: this.props.salesmanId
            }
        });
        if (this.dsSupplyList.dataSourceStorage.state === "completed") {
            this.setState((p) => ({}));
        }
    }
}

export default withRouter(SupplyList);
